import { render } from "./InitInverter.vue?vue&type=template&id=1d18c89f"
import script from "./InitInverter.vue?vue&type=script&lang=js"
export * from "./InitInverter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__